import { useSettlements } from '@services/settlements/queries/useSettlements'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Card } from '@/components/ui/card'
import { cn } from '@/lib/utils'

import { absoluteAmount, formatDate, isUnderpayment, money } from './format'

/** The tenant's published settlements. Used inside the Nájom tab. */
export function UserSettlementsList() {
  const { t } = useTranslation('settlement')
  const { data, isLoading } = useSettlements({})

  if (isLoading) {
    return <div className="h-32 animate-pulse rounded-2xl bg-ink/[0.04]" />
  }

  if (!data || data.results.length === 0) {
    return (
      <Card className="p-6">
        <p className="m-0 text-sm text-muted-foreground">{t('user.empty')}</p>
      </Card>
    )
  }

  return (
    <div className="space-y-3">
      {data.results.map((settlement) => {
        const underpayment = isUnderpayment(settlement.grand_total)

        return (
          <Link
            key={settlement.id}
            to={`/user/settlements/${settlement.id}`}
            className="block no-underline"
          >
            <Card className="flex flex-wrap items-center justify-between gap-3 p-5 transition-colors hover:border-primary/40">
              <div>
                <p className="m-0 font-display text-lg font-bold text-ink">
                  {settlement.title}
                </p>
                <p className="m-0 text-sm text-muted-foreground">
                  {formatDate(settlement.period_start)} –{' '}
                  {formatDate(settlement.period_end)}
                </p>
              </div>

              {settlement.grand_total !== null && (
                <span
                  className={cn(
                    'font-display text-lg font-bold tabular-nums',
                    underpayment ? 'text-destructive' : 'text-success'
                  )}
                >
                  {underpayment
                    ? t('result.underpayment')
                    : t('result.overpayment')}{' '}
                  {money(absoluteAmount(settlement.grand_total))}
                </span>
              )}
            </Card>
          </Link>
        )
      })}
    </div>
  )
}
